import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";


function RoomStatistics() {
    const navigate = useNavigate();
    useEffect(() => 
      {
        const scriptUrls = 
        [
            '/assets/js/jquery.min.js',
            '/assets/js/bootstrap.bundle.min.js',
            '/assets/js/moment.min.js',
            '/assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
            '/assets/vendor/overlay-scroll/custom-scrollbar.js',
            '/assets/vendor/daterange/daterange.js',
            '/assets/vendor/daterange/custom-daterange.js',
            '/assets/vendor/jquery-ui/jquery-ui.min.js',
            '/assets/vendor/jquery-ui/custom.js',
            '/assets/vendor/datatables/dataTables.min.js',
            '/assets/vendor/datatables/dataTables.bootstrap.min.js',
            '/assets/vendor/datatables/custom/custom-datatables.js',
            '/assets/js/custom.js',
            'assets/vendor/apex/apexcharts.min.js',
            'assets/vendor/apex/custom/rooms/admissions.js'
            
        ];

        let isCancelled = false;

        const loadScriptsSequentially = async () =>
          {
            for (const url of scriptUrls)
              {
                if (isCancelled) break;

                await new Promise((resolve, reject) =>
                {
                    const script = document.createElement('script');
                    script.src = url;
                    script.onload = resolve;
                    script.onerror = reject;
                    document.body.appendChild(script);
                });
            }
        };

        loadScriptsSequentially();

        return () => {
            isCancelled = true;
        };
    }, []);
    const handleSubmit = () => {
      // Optional: Add form validation logic here
      navigate("/available-rooms");
      setTimeout(() => {
          window.location.reload(); // force page refresh after navigation
      }, 100);
  };

    return (<>
   
          {/* App container starts */}
          <div className="app-container">
        
            {/* App hero header starts */}
            <div className="app-hero-header d-flex align-items-center">
              {/* Breadcrumb starts */}
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="index-2.html">
                    <i className="ri-home-3-line" />
                  </a>
                </li>
                <li className="breadcrumb-item">Rooms</li>
                <li className="breadcrumb-item text-primary" aria-current="page">
                  Statistics
                </li>
              </ol>
              {/* Breadcrumb ends */}
              {/* Sales stats starts */}
              <div className="ms-auto d-lg-flex d-none flex-row">
                <div className="input-group">
                  <span className="input-group-text bg-primary-lighten">
                    <i className="ri-calendar-2-line text-primary" />
                  </span>
                  <input type="text" id="abc" className="form-control custom-daterange" />
                </div>
              </div>
              {/* Sales stats ends */}
            </div>
            {/* App Hero header ends */}
            {/* App body starts */}
            <div className="app-body">
              {/* Row starts */}
              <div className="row gx-4">
                <div className="col-sm-12">
                  <div className="card mb-4">
                    <div className="card-header">
                      <h5 className="card-title">Statistics</h5>
                    </div>
                    <div className="card-body">
                      <div className="chart-height-xxl">
                        <div id="admissions" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Row ends */}
              {/* Row starts */}
              <div className="row gx-4">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-header">
                      <h5 className="card-title">Beds Availability</h5>
                    </div>
                    <div className="card-body">
                      {/* Table starts */}
                      <div className="table-outer">
                        <div className="table-responsive">
                          <table className="table truncate align-middle m-0">
                            <thead>
                              <tr>
                                <th width="60px">Bed No</th>
                                <th width="100px">Patient</th>
                                <th width="100px">Department</th>
                                <th width="100px">Admission Date</th>
                                <th width="100px">Age</th>
                                <th width="100px">Gender</th>
                                <th width="100px">Availablity</th>
                                <th width="100px">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>1</td>
                                <td>Liza Morrison</td>
                                <td>Cardiology</td>
                                <td>20/02/2024</td>
                                <td>65</td>
                                <td>Female</td>
                                <td><span className="badge border border-success text-success">Occupied</span></td>
                                <td>
                                  <button className="btn btn-primary" disabled>Discharge</button>
                                </td>
                              </tr>
                              <tr>
                                <td>2</td>
                                <td>Kirsten Downs</td>
                                <td>Neurology</td>
                                <td>25/02/2024</td>
                                <td>86</td>
                                <td>Male</td>
                                <td><span className="badge border border-danger text-danger">Reserved</span></td>
                                <td>
                                  <button className="btn btn-secondary"
                                   data-bs-toggle="modal" data-bs-target="#confirmModalSm">Confirm</button>
                                </td>
                              </tr>
                              <tr>
                                <td>3</td>
                                <td>xxx</td>
                                <td>xxx</td>
                                <td>xxx</td>
                                <td>xx</td>
                                <td>xxx</td>
                                <td><span className="badge border border-info text-info">Available</span></td>
                                <td>
                                  
                                  <button  className="btn btn-primary" onClick={handleSubmit}>View</button>
                                </td>
                              </tr>
                              <tr>
                                <td>4</td>
                                <td>Vanessa Lowery</td>
                                <td>Orthopedics</td>
                                <td>28/02/2024</td>
                                <td>38</td>
                                <td>Female</td>
                                <td><span className="badge border border-secondary text-dark">Other</span></td>
                                <td>
                                  <button className="btn btn-primary" disabled>Not Available</button>
                                </td>
                              </tr>
                              <tr>
                                <td>5</td>
                                <td>Malik Holder</td>
                                <td>Neurology</td>
                                <td>23/02/2024</td>
                                <td>59</td>
                                <td>Male</td>
                                <td><span className="badge border border-danger text-danger">Reserved</span></td>
                                <td>
                                  <button className="btn btn-secondary"
                                   data-bs-toggle="modal" data-bs-target="#confirmModalSm" >Confirm</button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      {/* Table ends */}
                      {/* Modal starts */}
                      <div className="modal fade" id="confirmModalSm" tabIndex={-1} aria-labelledby="confirmModalSmLabel" aria-hidden="true">
                        <div className="modal-dialog modal-sm">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title" id="confirmModalSmLabel">
                                Confirm
                              </h5>
                              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                            </div>
                            <div className="modal-body">
                              <div className="d-flex gap-2 justify-content-end">
                                <button type="button" className="btn btn-outline-secondary">
                                  Cancel
                                </button>
                                <button type="button" className="btn btn-primary" onClick={handleSubmit}>
                                  Book
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Row ends */}
            </div>
            {/* App body ends */}
          
          </div>
          {/* App container ends */}
    </>)

}
export default RoomStatistics;